// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2V7EV","row":"styles_row__7VEYG"};